import { Text, TextProps } from '@everlywell/ui-kit';
import React from 'react';

export type EyebrowProps = TextProps & {
  children: string;
};

/**
 * TODO: should this be a variant of the Text component?
 */
function Eyebrow(props: EyebrowProps): JSX.Element {
  return <Text as="span" size="lg" color="viridian.base" {...props} />;
}

export default Eyebrow;
